import messages from './en_US.po'

// export a merged messages json
export default messages
